<template>
  <div>
     <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Setting  /  Network</h5></vs-button>
    </vs-row>
    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Network</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <vs-card style="border-radius: 20px;">
       <div class="mt-2" slot="header" >
        <vs-row id="center">
        <h3 id="p" style="color: #111111">
            Network
          </h3>
          <h3 id="v" style="color: #111111">
            Network
          </h3>
        <vs-spacer />
          <btnPrint :dataList="networkList" :headerName="'Network'" :header="header"/>
          <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button  class="mr-2"  radius @click="onExport" color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>
          <vs-tooltip  text="Add New Network" position="left" >
             <h6> <vs-button color="success"  style="border-radius: 20px;" size="sm" icon="add" v-b-modal.addnetwork type="filled">Add Network</vs-button></h6>
        </vs-tooltip>&nbsp;&nbsp;
        <!-- <vs-button color="#007bff" type="line" icon="add" to="/createnetwork">Add New Network</vs-button> -->
       
        </vs-row>
       
        
      </div>
     
      
      <br>
 <div ><NetworkList :key="componentKey" /></div>
      
    </vs-card>
     <b-modal id="addnetwork" no-close-on-backdrop="false" hide-header-close centered hide-footer  size="lg" >
          <template #modal-title>
     <h4 style="color: #5fa74b">Create New Network</h4> 
    </template>
         <div>
            <CreateNetwork  />
        </div>
  </b-modal>
    
  </div>
</template>

<script>
import btnPrint from '../Page/Button/btnPrint.vue'
import NetworkList from '../dashboard/Network/NetworkList'
import CreateNetwork from '../Page/Subpage/CreateNetwork.vue'
import moment from 'moment'
import XLSX from 'xlsx' // import xlsx
import html2pdf from 'html2pdf.js'
import jsPDF  from 'jspdf'
import 'jspdf-autotable'
export default {
  name: "Network",
  data() {
    btndelnw: ''
    return {
      componentKey: 0,
      role: '',
      dataBody: [],
      dataExport: [],
      nwList: [],
      networkList: [],
      header: ['Name','Gateway','Sensors']
    };
  },
  components: {
    NetworkList,
    CreateNetwork,
    btnPrint
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    // export PDF
     exportPDF() {
          this.role = this.$session.get('role')
          console.log(this.role)
          this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result)=>{
              this.nwList = result.data
              console.log(this.nwList)
               this.nwList.forEach(element => {
         this.dataBody.push({name: element.name,gateway: element.gwc,Sensors: element.sc});
      });
      console.log(this.dataBody)
      var doc = new jsPDF('p', 'pt');
      doc.setFontSize(11).text('Network List', 40, 40); //header
      var newDat = moment().format('MM/DD/YYYY hh:mm:ss'); 
      doc.setFontSize(7).text(505,25,newDat); //timestamp
      var values = this.dataBody.map( (elemento) => Object.values(elemento));
      console.log(values)
      doc.autoTable({theme: 'striped',headStyles: {fillColor: [105, 181, 83] ,textColor: [255, 255, 255]} , styles: { fontSize: 8 ,theme: 'plain'},
          head: [['Name','Gateway','Sensors']],
          body: values,margin: {top: 50}
      })
      doc.save('exportNetworkList.pdf'); 
      this.dataBody = []; //Clear dataBody
           })
      // console.log(this.sensorlist) 
     
      
    },
    // export xlsx
    onExport() {
      this.role = this.$session.get('role')
    console.log(this.role)
    this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result)=>{
      this.nwList = result.data
      this.nwList.forEach(element => {
         this.dataExport.push({name: element.name,gateway: element.gwc,sensors: element.sc});
      });
      console.log(this.dataExport)
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb,'exportNetwork.xlsx')
      this.dataExport = [];
    })
      
    }
  },
  created() {
    this.role = this.$session.get('role')
    this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result)=>{
      result.data.forEach(element => {
        this.networkList.push({name: element.name,gateway: element.gwc,sensors: element.sc});
      });
      console.log('network')
      console.log(this.networkList)
    })
    
  }
}
</script>
<style scoped>
.vs-button{
  border-radius: 20px;
}
  button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
    border-radius: 5px;
  }
  th .sort-th .th-sort-icon {
    color: white;
    padding: 0px;
  }
  #p {
  display: inline;
}
#v {
  display: none;
}
#center{
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) { 
  .a{
     /* background: pink; */
     width: 200px;
   }
   #v {
  display: inline;
}
#p {
  display: none;
}
   .vuesax-app-is-ltr .vs-table--search-input{
     width: 100px;
     padding: o;
   }
   .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
} 
        }
</style>